// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".validation__content svg{color:#e74c3c}", "",{"version":3,"sources":["webpack://./src/components/fields/Validation.vue"],"names":[],"mappings":"AAOI,yBACE,aAAA","sourcesContent":["@import '../../styles/_mixins.scss';\n@import '../../styles/_variables.scss';\n\n.validation {\n\n  &__content {\n\n    svg {\n      color: #e74c3c;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
